// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /event/team-schedule-get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeEventTeamScheduleGetBody,
  typeEventTeamScheduleGetOutput200,
} from "../../sdk/event/postEventTeamScheduleGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildEventTeamScheduleGetQueryKey(
  payload: typeEventTeamScheduleGetBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`teamId:${JSON.stringify(payload.teamId)}`);
  queryKeySegments.push(`seasonId:${JSON.stringify(payload.seasonId)}`);
  queryKeySegments.push(`timeZone:${JSON.stringify(payload.timeZone)}`);
  return [
    "post:event:eventTeamScheduleGet",
    "svc:events-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeEventTeamScheduleGetOutput200,
    unknown,
    typeEventTeamScheduleGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useEventTeamScheduleGet(
  payload: typeEventTeamScheduleGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildEventTeamScheduleGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postEventTeamScheduleGet(payload),
    ...resolvedOptions,
  });
}
